export const LENGTH_VALUES = {
  SSN_LAST_4: 4,
  SSN: 9,
  MRNS: 10,
  CITIZENSHIP: 30,
  PHONE_NUMBER: { MAX: 14, MIN: 7 },
  HOME_PHONE: { MAX: 14, MIN: 8 },
  EMERGENCY_PHONE: { MAX: 11, MIN: 7 },
  PASSWORD: { MAX: 256, MIN: 6 },
  LAST_NAME: { MAX: 40, MIN: 1 },
  FIRST_NAME: { MAX: 40, MIN: 1 },
  MIDDLE_NAME: { MAX: 40, MIN: 1 },
  USERNAME: { MAX: 70, MIN: 3 },
  ALIAS: { MAX: 16, MIN: 1 },
  ADDRESS_1: { MAX: 40, MIN: 1 },
  ADDRESS_2: { MAX: 40, MIN: 1 },
  CITY: { MAX: 30, MIN: 1 },
  STATE: { MAX: 20, MIN: 1 },
  POSTAL_CODE: { MAX: 10, MIN: 5 },
  COUNTRY: { MAX: 20, MIN: 1 },
  BIO: { MAX: 500, MIN: 1 },
  ORGANIZATION: { MAX: 500, MIN: 1 },
  REASON_NOTE: { MAX: 50 },
  ROOM: { MAX: 10 },
  COPAY: { MAX: 10 },
  CHAT_NAME: { MAX: 64 },
  MEMBER_ID: { MIN: 2, MAX: 80 },
  GROUP_NUMBER: { MIN: 1, MAX: 50 },
};

export const PATTERNS = {
  USERNAME_CHARACTERS: /^[A-Za-z0-9 @._+-]+$/,
  USERNAME_REPEATING: /^(?!.*@.*@)(?!.*\+.*\+)[A-Za-z0-9 @.+_-]{1,70}$/,
  USERNAME_NO_SPACES: /^\S+$/,
  USERNAME_SPACES_AND_REPEATING: /^(?!.*\s)(?!.*([;:,\\|/±!?#$%^&*(){}@._+-])\1)[A-Za-z0-9;:,\\|/±!?#$%^&*(){}@._+-]+$/,
  USERNAME: /^(?!.*@.*@)(?!.*\+.*\+)[A-Za-z0-9@.+_-]{3,70}$/,
  POSTAL_CODE: /^\d{5}$|^\d{5}-\d{4}$/,
  PASSWORD: {
    LOWER_CASE_CHARACTER: /(?=.*[a-z])/,
    UPPER_CASE_CHARACTER: /(?=.*[A-Z])/,
    NUMERIC_CHARACTER: /(?=.*\d)/,
    SPECIAL_CHARACTER: /(?=.*[^a-zA-Z0-9\s ])/,
    MIN_LENGTH: /(?=.{6,})/,
  },
  AMOUNT: /^\d+(\.\d{0,2})?$/,
  SSN: /^\d+$/,
  PHONE_HOME: /^\d{8,14}$/,
  // email rule from backend
  EMAIL: /^[\w+\-.]+@[a-z\d\-]+(\.[a-z\d\-]+)*\.[a-z]+$/,
  PHONE_NUMBER: /^\+?\d{10,14}$/,
  HAS_ALPHABETICAL_CHARACTER: /(?=.*[a-zA-Z])/,
  ONLY_NUMERIC: /\D/g,
  YYYY_MM_DD_REGEX: /^\d{4}-\d{2}-\d{2}$/,
  REGEXP_SPECIAL_CHARS: /[.*+?^${}()|[\]\\]/g,
  URL: /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()!@:%_+.~#?&/=]*)/gim,
  CHARACTERS: /[+\-_%@.]/g,
};



// WEBPACK FOOTER //
// ./src/constants/validations.js